import React from "react";
import "./AboutPage.css";

/* Components */
import HeaderPage from "../../components/Header/HeaderPage";
import Footer from "../../components/Footer/Footer";
import ParticleBackground from "../../components/ParticlesBg/ParticleBackground";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import cv from "../../cv/cv.pdf";

/* Multi idioma */
import { FormattedMessage } from "react-intl";

/* Img */
import imgabout from "../../img/home.jpg";

/* Icons */
import {  
  FaHtml5,
  FaJsSquare,
  FaReact,
  FaNodeJs,
  FaPhp,
  FaDatabase,
  FaFigma,
  FaRocket,
  FaHandshake,
} from "react-icons/fa";
import { SiSass, SiSolidity, SiWeb3Dotjs } from "react-icons/si";

const About = () => {
  function readMore() {
    let btnHide = document.querySelector("#btn-hide");
    let parrafoActive = document.querySelector(".parrafo-active");

    parrafoActive.classList.toggle("show");

    if (parrafoActive.classList.contains("show")) {
      btnHide.innerHTML = "↑";
    } else {
      btnHide.innerHTML = "Read more";
    }
  }

  const skills = [
    {
      id: 1,
      icon: <FaHtml5 color="#E44D26" />,
      name: "Frontend Development\n(HTML / CSS / Sass)",
      messageId: "about-skills-1",
      defaultMessage:
        "Over 6 years of experience creating clean, responsive, and accessible web interfaces. I write semantic HTML and maintain structured CSS with Sass, applying Flexbox, Grid, and BEM for scalable, modern layouts.",
    },
    {
      id: 2,
      icon: <FaJsSquare color="#F7DF1E" />,
      name: "JavaScript\n(ES6+)",
      messageId: "about-skills-2",
      defaultMessage:
        "Expert-level understanding of modern JavaScript across frontend and backend environments. I focus on writing efficient, modular, and maintainable code, leveraging ES6+ features for high performance and clean architecture.",
    },
    {
      id: 3,
      icon: <FaReact color="#61DAFB" />,
      name: "Frontend Frameworks\n(React / Vue.js / Angular / Next.js)",
      messageId: "about-skills-3",
      defaultMessage:
        "Extensive experience developing dynamic and data-driven web applications. Strong command of React and Next.js for SSR and modern UI patterns, Vue.js with Vuex for reactivity, and Angular for large-scale enterprise applications.",
    },
    {
      id: 4,
      icon: <FaNodeJs color="#339933" />,
      name: "Backend Development\n(Node.js / Express / PHP)",
      messageId: "about-skills-4",
      defaultMessage:
        "Building reliable, secure, and scalable backend systems. Experienced with Node.js and Express for RESTful APIs and real-time services, and PHP for legacy and CMS-based backends following modern coding standards.",
    },
    {
      id: 5,
      icon: <SiSolidity color="#363636" />,
      name: "Blockchain Development\n(Solidity / Web3.js)",
      messageId: "about-skills-5",
      defaultMessage:
        "Professional experience designing and deploying smart contracts and decentralized apps (DApps). Skilled in Solidity and Web3.js, focusing on secure, optimized blockchain solutions and Ethereum-based integrations.",
    },
    {
      id: 6,
      icon: <FaDatabase color="#4DB33D" />,
      name: "Database Management\n(MongoDB / MySQL / PostgreSQL)",
      messageId: "about-skills-6",
      defaultMessage:
        "Designing and maintaining efficient data architectures for web and mobile systems. Experienced in both relational and NoSQL databases, optimizing queries and ensuring high performance for large-scale applications.",
    },
    {
      id: 7,
      icon: <FaFigma color="#F24E1E" />,
      name: "UI/UX Design",
      messageId: "about-skills-7",
      defaultMessage:
        "Crafting intuitive user experiences and visually balanced interfaces. I apply design principles that enhance usability, accessibility, and consistency across devices, emphasizing clarity and brand identity.",
    },
    {
      id: 8,
      icon: <FaRocket color="#FF6F61" />,
      name: "Website Optimization & SEO",
      messageId: "about-skills-8",
      defaultMessage:
        "Improving page load speed, structure, and search engine visibility. I focus on performance tuning, code efficiency, and metadata strategy to ensure a strong technical SEO foundation and a smoother user experience.",
    },
    {
      id: 9,
      icon: <FaHandshake color="#3b82f6" />,
      name: "Collaboration & Communication",
      messageId: "about-skills-9",
      defaultMessage:
        "Strong record of effective teamwork and communication in international remote environments. Since 2019, I’ve been collaborating with global clients and teams, maintaining clear communication, punctual delivery, and mutual trust in every project.",
    },
  ];

  return (
    <div>
      <HeaderPage />
      <ParticleBackground />

      <main>
        <section className="sobre-mi-seccion" id="sobre-mi">
          <div className="sobre-mi-container">
            <div className="sobre-mi-img-container">
              <img src={imgabout} alt="Profile" className="sobre-mi-img" />

              <a
                href={cv}
                target="_blank"
                rel="noopener noreferrer"
                download="cv.pdf"
                className="btn-codigo cv buttonDownload"
              >
                <FormattedMessage id="btn-cv" defaultMessage="Download CV" />
              </a>
            </div>

            <div className="sobre-mi-info">
              <p>
                <FormattedMessage
                  id="about-info-1"
                  defaultMessage="Hi, I'm Yusuke Morimoto, a senior web developer specializing in full-stack and blockchain development. I have been working internationally since 2019 and enjoy building innovative web experiences that combine technology and design."
                />
              </p>

              <div className="hide parrafo-active">
                <p>
                  <FormattedMessage
                    id="about-info-2"
                    defaultMessage="In addition to my technical skills, I take pride in being reliable & punctual promise-keeper and successful communicator with international clients."
                  />
                </p>
                <p>
                  <FormattedMessage
                    id="about-info-3"
                    defaultMessage="The other properties that you can expect me to have would be - a strong challenger with time & conditions, hard-working, working full-time, comfortable cooperating across time zone, client-oriented, focusing on dedication & advancements."
                  />
                </p>
              </div>

              <div className="btn-info">
                <div
                  className="custom-btn btn-codigo"
                  id="btn-hide"
                  onClick={readMore}
                >
                  <span>Read more</span>
                </div>
              </div>
            </div>
          </div>

          <div className="skill-seccion">
            <h1 className="heading">Skills</h1>
            <div className="skill-container">
              {skills.map((skill, index) => (
                <div
                  className="skill-card"
                  data-aos={index % 2 === 0 ? "flip-left" : "flip-right"}
                  data-aos-delay="300"
                  key={skill.id}
                >
                  <div className="skills-icon text-4xl mb-3">{skill.icon}</div>
                  <h2 className="skill-name">{skill.name}</h2>
                  <p className="skill-info">
                    <FormattedMessage
                      id={skill.messageId}
                      defaultMessage={skill.defaultMessage}
                    />
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default About;



